import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";

const OFFICES = [
  { city: "Kampala", region: "Uganda", phones: ["+256 700 259 675", "+256 701 238 066", "+256 704 412 030"] },
  { city: "New York City", region: "New York, USA", phones: ["+1 614 571 9333"] },
  { city: "Boston", region: "Massachusetts, USA", phones: ["+1 617 291 6821"] },
  { city: "Columbus", region: "Ohio, USA", phones: ["+1 614 571 9333"] },
];

export default function Footer() {
  return (
    <footer className="bg-secondary text-secondary-foreground border-t-4 border-red-600 mt-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="mb-5" data-testid="footer-logo">
            <div className="font-display text-3xl font-bold tracking-tight">TIGAWA<span className="text-accent"> PROPERTIES</span></div>
            <div className="text-[10px] tracking-[0.22em] uppercase font-bold mt-1 opacity-70">Your Trusted Real Estate Partner</div>
          </div>
          <p className="text-sm text-secondary-foreground/80 max-w-md leading-relaxed">
            Uganda&apos;s national property platform. Connecting sellers, buyers, agents, developers, banks, surveyors, lawyers, contractors, and diaspora investors — from Kampala to Karamoja.
          </p>
          <ul className="space-y-2 text-sm text-secondary-foreground/80 mt-6">
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 shrink-0" /> info@tigawaproperties.com</li>
            <li className="flex items-start gap-2"><Globe className="w-4 h-4 mt-0.5 shrink-0" /> www.tigawaproperties.com</li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-base font-semibold mb-4">Marketplace</h4>
          <ul className="space-y-2 text-sm text-secondary-foreground/80">
            <li><Link to="/listings" className="hover:text-accent">Browse Listings</Link></li>
            <li><Link to="/sell" className="hover:text-accent">Sell Property</Link></li>
            <li><Link to="/sell" className="hover:text-accent">List Land</Link></li>
            <li><Link to="/contact" className="hover:text-accent">Book Inspection</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display text-base font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-secondary-foreground/80">
            <li><Link to="/services" className="hover:text-accent">Land Surveying</Link></li>
            <li><Link to="/services" className="hover:text-accent">Title Processing</Link></li>
            <li><Link to="/services" className="hover:text-accent">Construction</Link></li>
            <li><Link to="/services" className="hover:text-accent">Diaspora Services</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display text-base font-semibold mb-4">Our Offices</h4>
          <ul className="space-y-4 text-sm text-secondary-foreground/80" data-testid="footer-offices">
            {OFFICES.map((o) => (
              <li key={o.city} className="flex items-start gap-2" data-testid={`footer-office-${o.city.toLowerCase().replace(/\s+/g, "-")}`}>
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-accent" />
                <div>
                  <div className="font-semibold text-secondary-foreground">{o.city} <span className="opacity-60 font-normal">· {o.region}</span></div>
                  <div className="flex flex-wrap gap-x-2 items-center mt-0.5">
                    <Phone className="w-3 h-3 opacity-60" />
                    <span>{o.phones.join(" · ")}</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-wrap items-center justify-between gap-3 text-xs text-secondary-foreground/70">
          <span>© {new Date().getFullYear()} TIGAWA PROPERTIES LTD. All rights reserved.</span>
          <span className="font-mono">Kampala · New York City · Boston · Columbus</span>
        </div>
      </div>
    </footer>
  );
}
